import styled from '@emotion/styled';

import { containerWidths, mq, pageGutter } from '@/lib/theme';

/**
 * Centres page content and caps its width, with the gutters the whole site
 * shares. `narrow` is for single-column flows (checkout, payment links,
 * errors) where a wide line length hurts.
 */
export const Container = styled.div<{ narrow?: boolean }>`
	width: 100%;
	margin: 0 auto;
	padding: 0 ${pageGutter.mobile};

	${mq.lg} {
		max-width: ${({ narrow }) => (narrow ? '760px' : containerWidths.lg)};
	}
	${mq.xl} {
		max-width: ${({ narrow }) => (narrow ? '760px' : containerWidths.xl)};
		padding: 0 ${pageGutter.desktop};
	}
	${mq.xxl} {
		max-width: ${({ narrow }) => (narrow ? '760px' : containerWidths.xxl)};
	}
`;
